import React, { Component } from "react";
import WaveSurfer from "wavesurfer.js";
import {
  Box, FormControl,
} from "@mui/material";
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import PauseCircleIcon from '@mui/icons-material/PauseCircle';

function formatTime(seconds) {
  const date = new Date(seconds * 1000);
  const hours = date.getUTCHours().toString().padStart(2, '0');
  const minutes = date.getUTCMinutes().toString().padStart(2, '0');
  const secondsWithMilliseconds = (date.getUTCSeconds() + date.getUTCMilliseconds() / 1000).toFixed(3);

  return `${hours}:${minutes}:${secondsWithMilliseconds.replace('.', ',').padStart(6, '0')}`;
}

class Waveform extends Component {
  
  state = {
    playing: false,
    duration: 0,
    currentTime: 0
  };


  componentDidMount() {
    const track = document.querySelector("#track");

    // this.waveform = WaveSurfer.create(options);
    this.waveform = WaveSurfer.create({
      // barWidth: 3,
      barRadius: 1,
      // barGap: NaN,
      // barMinHeight: 1,
      // cursorWidth: 1,
      container: "#waveform",
      // backend: "WebAudio",
      height: 80,
      
      // responsive: true,
      waveColor: "#2CC382",
      progressColor: "#51bff1",
      cursorColor: "#FF0000",
      // 추가
      splitChannels: false,
      normalize: false,
      cursorWidth: 2,
      barWidth: 1,
      // barHeight: 0.5,
      // barMinHeight: 1,
      barHeight: 3,
      fillParent: true,
      hideScrollbar: true,

    });

    this.waveform.on("ready", () => {
      const audioDuration = this.waveform.getDuration();
      this.setState({ duration: audioDuration.toFixed(3) });
    });

    this.waveform.on("audioprocess", () => {
      const currentTime = this.waveform.getCurrentTime();
      this.setState({ currentTime: currentTime.toFixed(3) });
    });

    this.waveform.load(track);
  }

  handlePlay = () => {
    // console.log('토글')
    this.setState({ playing: !this.state.playing });
    this.waveform.playPause();
    // wavesurfer.skip(5) 5 , -5
  };

  handleTimeChange = (event) => {
    const newTime = parseFloat(event.target.value);
    this.waveform.setCurrentTime(newTime.toFixed(3));
    this.setState({ currentTime: newTime.toFixed(3) });
    // console.log('newTime' , newTime)
  };

  

  componentDidUpdate(prevProps) {
    const { open, stopWaveform, setWaveSec, replay, setReplay } = this.props;
    const { playing } = this.state;
    // const { playing, duration, currentTime } = this.state;

    // console.log('waveform url',url)

    if(!open && !playing){
      stopWaveform();
      this.setState({ playing: false });
    }else if (open !== prevProps.open && !open && playing && !prevProps.open) {
      this.handlePlay();
      stopWaveform();
      this.setState({ playing: false });
    }else if(!open && playing){
      this.handlePlay();
      stopWaveform();
      this.setState({ playing: false });
    }

    if(replay !== ""){
      // console.log('다시 재생할 시간' , replay)
      const replay_time = replay
      setReplay("")
      // 문자를 다시 숫자 시간으로
      const formattedTimeInSeconds = 
          parseInt(replay_time.split(':')[0]) * 3600 +
          parseInt(replay_time.split(':')[1]) * 60 +
          parseFloat(replay_time.split(':')[2].replace(',', '.'));

      // console.log('바꾼 시간', formattedTimeInSeconds)
      this.waveform.setCurrentTime(formattedTimeInSeconds);
      this.setState({ currentTime: formattedTimeInSeconds });
      setWaveSec(replay_time)
      if(!this.state.playing){
        this.handlePlay();
      }
      setReplay("")
    }else{
      setWaveSec(formatTime(this.state.currentTime))
    }
    

  }

  render() {

    const { url } = this.props;

    // console.log('url', url)
    // const { url, open} = this.props;

    // const { playing } = this.state;

    // console.log('url wavform' , url)

    // console.log('상태' , open, playing )
    // console.log('========================')

    // const url =
    //   window.location.origin.replace(':3000',':9680')+"/sampleAudioInfo?idx=22";

    // console.log('waveform url',url)

    return (
      <Box>
        <Box sx={{display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          // height: "88px",
          // width: "100%",
          // background: "transparent",
          border : "3px solid #3e36a5",
          borderRadius : "3px",
          margin: "8px",
          padding: "2px 4px",
          gap: "2rem"}}>
          <Box sx={{width: "800px", height: "80px"}} id="waveform" />
          <audio id="track" src={url} />
        </Box>
        
        <Box display="flex" sx={{margin: "0 8px",alignItems:"center"}}>
          <Box sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "30px",
            height: "28px",
            background: !this.state.playing ? "#3e36a5": "red",
            borderRadius: "50%",
            border: "none",
            outline: "none",
            cursor: "pointer",
            padding: "3px",
            color: "#fff",
            marginRight:"8px",
            "&:hover": {
              background: "green",
              color: "#fff"
            }
          }} onClick={this.handlePlay}>
            {/* {!this.state.playing ? <PlayCircleIcon fontSize="large" /> : <PauseCircleIcon fontSize="large" />} */}
            {!this.state.playing ? <FormControl sx={{width:"26px", height:"26px"}}><PlayCircleIcon sx={{margin:"auto"}} /></FormControl> : <FormControl sx={{width:"26px", height:"26px"}}><PauseCircleIcon sx={{margin:"auto"}} /></FormControl>}
          </Box>
          <Box display="flex" sx={{marginRight:"16px", fontWeight:800, alignItems: "center"}}>
            <Box sx={{fontWeight:700, marginBottom:"4px",marginRight:"8px"}}>시간 컨트롤</Box>
            <Box><input
            type="range"
            min={0}
            max={this.state.duration}
            value={this.state.currentTime}
            onChange={this.handleTimeChange}
          /></Box>
          </Box>
          <Box display="flex" sx={{marginRight:"16px", fontWeight:800, alignItems: "center"}}>
            <Box sx={{fontWeight:700, marginBottom:"4px",marginRight:"8px"}}>재생 시간 :</Box>
            {/* <Box sx={{width:"100px"}}>{this.state.currentTime} Sec</Box> */}
            <Box sx={{width:"110px"}}>{formatTime(this.state.currentTime)}</Box>
            
          </Box>
          <Box display="flex" sx={{marginRight:"16px", fontWeight:800, alignItems: "center"}}>
            <Box sx={{fontWeight:700, marginBottom:"4px",marginRight:"8px"}}>총 길이 :</Box>
            <Box sx={{width:"100px"}}>{this.state.duration} Sec</Box>
          </Box>
        </Box>
      </Box>
    );
  }
}

export default Waveform;
